export default __webpack_public_path__ + "static/media/chat.bb00c6f7.jpg";